import { useInfiniteQuery } from '@tanstack/react-query';

import * as ApiWiki from '@Api/Wiki';
import useSearchParams from '@Hooks/useSearchParams';
import { isBrowser } from '@Utils/checkRuntime';

export interface Params {
  ssr?: boolean;
  categoryId?: string | number;
  tagId?: string | number;
}

function useInfiniteWikiArticles(params?: Params) {
  const { ssr = true, categoryId, tagId } = params || {};
  const searchParams = useSearchParams();
  const initialPage = searchParams.get('page') || 1;
  const keys = ['infiniteWikiArticles', categoryId, tagId].filter(Boolean);
  const category = useInfiniteQuery(
    keys,
    ({ pageParam = 1 }) => {
      return ApiWiki.getWikiArticles({ page: pageParam || initialPage, categoryId, tagId });
    },
    {
      enabled: ssr || isBrowser,
      keepPreviousData: true,
      // TODO:backend бэкенд не возвращает номер страницы, из-за чего пагинация работает некорректно
      getNextPageParam: (lastPage) => {
        return lastPage.countLeft ? lastPage.page + 1 : null;
      },
    },
  );

  return category;
}

export default useInfiniteWikiArticles;
